import { MORPHEUS_3_WAY_CHAT_FEATURE_FLAG } from 'featureFlags/config';
import { useFeatureFlag, useParticipantsFeatureFlag } from 'featureFlags/hooks';

import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';

export const useIsMorpheus3WayChatFFEnabled = () => {
  const userMode = useUserMode();
  const participantFFEnabled = useParticipantsFeatureFlag(
    MORPHEUS_3_WAY_CHAT_FEATURE_FLAG
  );
  const myFFEnabled = useFeatureFlag(MORPHEUS_3_WAY_CHAT_FEATURE_FLAG);

  if (userMode === USER_MODES.dashboard) {
    return myFFEnabled;
  }

  return participantFFEnabled;
};
